module.exports = __webpack_public_path__ + "media/images/voice13-a9a71b057b761cc662d72e8f67387611.jpg";